var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3867 12.0001C10.3867 10.5867 11.5333 9.44006 12.9467 9.44006L17.1267 9.44006C18.54 9.44006 19.6867 10.5867 19.6867 12.0001C19.6867 13.4134 18.54 14.5601 17.1267 14.5601L16.1433 14.5601",
    fill: "#FFEDD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6133 12.0001C13.6133 13.4134 12.4667 14.5601 11.0533 14.5601L6.87334 14.5601C5.46001 14.5601 4.31334 13.4134 4.31334 12.0001C4.31334 10.5867 5.46001 9.44006 6.87334 9.44006L7.85668 9.44006",
    fill: "#FFEDD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3867 12.0001C10.3867 10.5867 11.5333 9.44006 12.9467 9.44006L17.1267 9.44006C18.54 9.44006 19.6867 10.5867 19.6867 12.0001C19.6867 13.4134 18.54 14.5601 17.1267 14.5601L16.1433 14.5601",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6133 12.0001C13.6133 13.4134 12.4666 14.5601 11.0533 14.5601L6.87331 14.5601C5.45998 14.5601 4.31331 13.4134 4.31331 12.0001C4.31331 10.5867 5.45998 9.44006 6.87331 9.44006L7.85665 9.44006",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.7ac30799005645563d769a8d1ec6257d.svg";
export { ForwardRef as ReactComponent };